import { AudioState } from './types';

export const INITIAL_STATE: AudioState = {
  source: '',
  isPlaying: false,
  duration: 0,
  position: 0,
  isLoading: true,
  playbackRate: 1,
};
